/* eslint-disable func-names */
import { TweenLite } from 'gsap';
import store from '../../utils/localStorageFallback';
import VERSION_OPTIONS from '../../../gutenberg/configs/versions';

const docReady = fn => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

const hideSections = () => {
  const storeVersion = store('version');
  let sectionsToHide = [];

  if (storeVersion === 'investor') {
    sectionsToHide = document.querySelectorAll(`.${storeVersion} , .investors`);
  } else {
    sectionsToHide = document.getElementsByClassName(`${storeVersion}`);
  }

  for (let i = 0; i < sectionsToHide.length; i += 1) {
    sectionsToHide[i].classList.remove('u-hidden');
  }
};

const forceRoleRedirect = () => {
  const user = store('version');

  if (document.body.classList.contains('adviser') || document.body.classList.contains('investor')) {
    // in a restricted page/ post / product.
    if (!document.body.classList.contains(user)) {
      // redirect to home if now allowed.
      document.location.href = '/';
    }
  }
};

const resourceCentreReload = () => {
  const path = document.location.pathname;

  if (path === '/resources/') {
    document.location.reload();
  }
};

docReady(() => {
  // DOM is loaded and ready for manipulation here
  // const btn = document.getElementById('modal-opener');
  const modal = document.querySelector('.modal');

  const toggleModal = () => {
    const currentState = modal.style.display;
    // If modal is visible, hide it. Else, display it.
    if (currentState === 'none') {
      modal.style.display = 'block';
    } else {
      modal.style.display = 'none';
    }
  };

  const showConfirmScreen = value => {
    const stepOne = document.getElementsByClassName('modal-content-role-select')[0];
    const stepTwo = document.getElementsByClassName(`${value}-confirm`)[0];
    TweenLite.to(stepOne, 0.3, { autoAlpha: 0, display: 'none' });
    TweenLite.to(stepTwo, 0.3, { autoAlpha: 1, delay: 0.3, display: 'block' });

    const advisorConfirm = document.getElementsByClassName('adviser-confirm-button')[0];
    const investorConfirm = document.getElementsByClassName('investor-confirm-button')[0];

    advisorConfirm.addEventListener('click', function() {
      store('version', 'adviser');
      hideSections();
      forceRoleRedirect();
      resourceCentreReload();
      toggleModal();
    });

    investorConfirm.addEventListener('click', function() {
      store('version', 'investor');
      hideSections();
      forceRoleRedirect();
      // eslint-disable-next-line no-use-before-define
      resourceCentreReload();
      toggleModal();
    });
  };

  // add in buttons to the dom
  for (let i = 0; i < VERSION_OPTIONS.length; i += 1) {
    const button = document.createElement('input');
    button.setAttribute('type', 'button');
    button.setAttribute('class', 'btn wp-block-button');
    button.setAttribute('value', VERSION_OPTIONS[i].value);
    button.innerHTML = VERSION_OPTIONS[i].label;

    const modalContent = document.querySelector('.modal-content-role-select');

    modalContent.appendChild(button);

    button.addEventListener('click', function() {
      showConfirmScreen(this.value);
    });
  }

  // eslint-disable-next-line no-unused-vars
  const resetVersion = () => {
    localStorage.removeItem('version');

    for (let i = 0; i < VERSION_OPTIONS.length; i += 1) {
      const sectionsToHide = document.getElementsByClassName(`${VERSION_OPTIONS[i].value}`);

      for (let j = 0; j < sectionsToHide.length; j += 1) {
        sectionsToHide[j].classList.add('u-hidden');
      }
    }

    if (!store('version')) {
      toggleModal();
    } else {
      hideSections();
    }
  };

  // btn.addEventListener('click', resetVersion);
  if (!store('version')) {
    toggleModal();
  } else {
    hideSections();
    // forceRoleRedirect();
  }
});
